import dayjs from "dayjs";

export default function GmtToLocal(gmtString) {
  gmtString = new Date(gmtString).toString().substring(4, 24);
  if (gmtString === "Dec 31 0000 19:03:58") gmtString = "N/A";
  return gmtString;
}

export function isMoreThan7Days(startDate, endDate) {
  const start = dayjs(startDate);
  const end = dayjs(endDate);
  return end.diff(start, "day") > 7;
}
